'use strict';

exports.__esModule = true;
exports['default'] = getEmptyImage;
var emptyImage = undefined;

function getEmptyImage() {
  if (!emptyImage) {
    emptyImage = new Image();
    emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
  }

  return emptyImage;
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-dnd-html5-backend/lib/getEmptyImage.js
// module id = 2488
// module chunks = 0